import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f4f970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "数字展厅", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tap" }, "正在开发中，敬请期待...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "实用，是最高的唯美", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "解决方案", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangyou3" }, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  class: "warpe clearfix",
  style: {"padding-top":"1rem"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "经典客户", -1))
const _hoisted_15 = { class: "items" }
const _hoisted_16 = { class: "img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "logo" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangzuo1" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangyou1" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "more" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "新闻中心", -1))
const _hoisted_26 = { class: "items" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "img" }
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  style: {"padding-bottom":"0.2rem"},
  class: "cont"
}
const _hoisted_31 = { class: "time" }
const _hoisted_32 = { class: "more" }

import { reactive,ref,onMounted ,watch, onUnmounted} from "vue";
import Tab from '@/components/produTab/Index.vue';
import Nav from '@/components/nav/Index.vue';
import { useRouter  } from "vue-router";
import { getAllGallery,getAllSolution,getEnum} from "@/api/index";
import { getCustomer,getNwes} from "@/api/backstage";



export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  isMobile: Boolean,
},
  setup(__props) {

const props = __props

const router = useRouter();

const mb =ref(false);


const datas: any = reactive({
  change:true,
  an:false,
  banner:'',
  gall:'',
  solut:'',
  customer:[],
  news:'',
  filurl:localStorage.getItem('fileUrel'),
  newsType:{},
  form: {
    newsType: "NEWS_NEWS",
    pageNum: 1,
    pageSize: 5,
    status:'STATUS_YES',
  },
});

const acrRef: any = ref(null);
const solut: any = ref(null); 

const a1: any = ref(null);
const sa1 = ref(false);
const a2: any = ref(null);
const sa2 = ref(false);
const a3: any = ref(null);
const sa3 = ref(false);
const getBanner = (banner: any) => {
  for(const item of banner) {
    item.description =  item.description.split(';');
  }
  datas.banner = banner;
};
const linkTo = (url: any) => {
 //   window.open(url, '_blank');
};

const next = () => {
  acrRef.value.next();
};

const prev = () => {
   acrRef.value.prev();
};
 
 

const getGall = () =>{
  getAllGallery().then((res: any) =>{
    for(const item of res.data){
      if(item.fileName) item.fileUrl = localStorage.getItem("fileUrel") + item.fileName;
    }
    datas.gall = res.data;
  });
};
const getSolut = () =>{
  getAllSolution().then((res: any) =>{
    datas.solut = res.data;
  });
};

const getCust = () =>{
  let query ={
    pageNum:1,
     pageSize: 8,
  };
  getCustomer(query).then((res: any) =>{
     for(let i = 0 ; i<  res.data.list.length;  i+=5){
           datas.customer.push(res.data.list.slice(i, i+5));
        }
    setTimeout(()=>{
        acrRef.value?.setActiveItem(0);
        },100);
  });
};


const getData = () =>{
  getNwes(datas.form).then((res: any) =>{
      for(const item of res.data.list){
      if(item.fileName) item.fileurl = localStorage.getItem("fileUrel") + item.fileName;
    }
    datas.news = res.data.list;
  });
};


const getNewsType = () =>{
   getEnum("NEWS").then((res: any) =>{
     datas.newsType = {};
      for (const item of res.data) {
        datas.newsType[item.enumKey] = item;
      }
  });
};
const tabCheck = (v: any) =>{
    router.push(`/website/product?p=${v}`);
};

  
 watch(
  () => props.isMobile,
  (newv, oldv) => {
       props.isMobile? mb.value = true : mb.value = false;    
  }
);

const open = (url: any) => {
     window.open(url, '_blank');
};
const change = () => {
  datas.change= false;
   setTimeout(() => {
      datas.change= true;
  }, 100);
};
const handleScroll = (e: any) => {
   const  scrollTop = e.target.scrollingElement.scrollTop;
    if((a1.value.offsetTop< scrollTop+500)&& sa1.value===false){
      sa1.value = true;
    }
    if((solut.value.offsetTop< scrollTop+500)&&datas.an ===false){
      datas.an = true;
    }
    if((a2.value.offsetTop< scrollTop+500)&& sa2.value===false){
      sa2.value = true;
    }
    if((a3.value.offsetTop< scrollTop+500)&& sa3.value===false){
      sa3.value = true;
      window.removeEventListener('scroll',handleScroll,false);
    }
};
  

onMounted(() => {
  mb.value =props.isMobile;
  getGall();
  getSolut();
  getCust();
  getData();
  getNewsType();
  window.addEventListener("scroll", handleScroll, false); 
});
onUnmounted(()=> {
  window.removeEventListener('scroll',handleScroll,false);
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(mb.value?'Mobile':'pc')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Nav, {
        isMobile: mb.value,
        onGetBanner: getBanner
      }, null, 8, ["isMobile"]),
      (datas.banner.length>1)
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 0,
            interval: 5000,
            arrow: "never",
            "pause-on-hover": false,
            height: "8.5rem",
            onChange: change,
            direction: "vertical"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.banner, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: datas.filurl+item.fileName,
                      alt: ""
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h1", {
                        class: _normalizeClass({banan:datas.change})
                      }, _toDisplayString(item.title), 3),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description, (p) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: _normalizeClass({banan2:datas.change}),
                          key: p
                        }, _toDisplayString(p), 3))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Tab, {
      isMobile: mb.value,
      onOnChecked: tabCheck
    }, null, 8, ["isMobile"]),
    _createElementVNode("div", {
      class: "gall",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (linkTo(datas.gall[0].linkUrl)))
    }, [
      _createElementVNode("img", {
        src: datas.gall[0]?.fileUrl,
        alt: ""
      }, null, 8, _hoisted_4),
      _createElementVNode("div", {
        class: _normalizeClass(["tex", {banan:sa1.value}]),
        ref_key: "a1",
        ref: a1
      }, [
        _createElementVNode("h3", null, _toDisplayString(datas.gall[0]?.description), 1),
        _hoisted_5,
        _hoisted_6
      ], 2)
    ]),
    _createElementVNode("div", {
      class: "solut",
      ref_key: "solut",
      ref: solut
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["tex", {banan:datas.an}])
      }, _hoisted_9, 2),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.solut, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item", [`item${index}`,datas.an?`a${index}`:'']]),
            key: index,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/website/solution')))
          }, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(item.title) + " ", 1),
              _hoisted_11
            ]),
            (!mb.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(item.description), 1))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", {
        class: _normalizeClass(["customer", {banan3:sa2.value}]),
        ref_key: "a2",
        ref: a2
      }, [
        _hoisted_14,
        _createVNode(_component_el_carousel, {
          ref_key: "acrRef",
          ref: acrRef,
          interval: 5000,
          autoplay: false,
          arrow: "never",
          "indicator-position": "none",
          height: "4rem"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.customer, (l, i) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(l, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          (item.imgName)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: datas.filurl+item.imgName,
                                alt: ""
                              }, null, 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("img", {
                            src: datas.filurl+item.fileName,
                            alt: ""
                          }, null, 8, _hoisted_19)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 512),
        _createElementVNode("div", {
          class: "arr ar1",
          onClick: prev
        }, _hoisted_21),
        _createElementVNode("div", {
          class: "arr ar2",
          onClick: next
        }, _hoisted_23),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/website/case')))
          }, " 查看更多")
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["news", {banan3:sa3.value}]),
        ref_key: "a3",
        ref: a3
      }, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.news, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: index,
              onClick: ($event: any) => (open(`/website/news/details?id=${item.id}`))
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("img", {
                  src: item.fileurl,
                  alt: ""
                }, null, 8, _hoisted_29)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", null, _toDisplayString(datas.newsType[item.newsType]?.enumName), 1),
                  _createTextVNode(" " + _toDisplayString(item.pushTime), 1)
                ]),
                _createElementVNode("h4", null, _toDisplayString(item.title), 1)
              ]),
              _createTextVNode(" " + _toDisplayString(item.orgName), 1)
            ], 8, _hoisted_27))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/website/news')))
          }, " 查看更多")
        ])
      ], 2)
    ])
  ], 2))
}
}

})